import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faUsers,
  faEnvelope,
  faTags,
  faStore,
  faGift,
  faCamera,
  faVideo,
  faFile,
  faPhotoFilm,
  faDollarSign,
  faFilePen,
  faUserPlus,
  faListCheck,
  faPaintBrush,
  faBolt,
} from '@fortawesome/free-solid-svg-icons';
import { TaskType } from '@common';

export interface TaskConfig {
  icon: IconDefinition;
  title: string;
  description: string;
}

export const TASK_CONFIG: Record<string, TaskConfig> = {
  [TaskType.ReviewBriefs]: {
    icon: faFile,
    title: 'Review Briefs',
    description: 'Take a look at the updated creative briefs and make sure everything looks good.',
  },
  [TaskType.ReviewContents]: {
    icon: faPhotoFilm,
    title: 'Review Content',
    description: 'Check out submitted content to see if it hits the mark and aligns with guidelines.',
  },
  [TaskType.ReviewProductSubmissions]: {
    icon: faGift,
    title: 'Review Product Submissions',
    description: 'Approve or request changes to members’ product order requests before fulfillment.',
  },
  [TaskType.SendPayments]: {
    icon: faDollarSign,
    title: 'Send Payments',
    description: 'Pay members for their collaboration efforts in this campaign.',
  },
  [TaskType.SendBriefs]: {
    icon: faFile,
    title: 'Send Briefs',
    description: 'Share details and creative direction with your members.',
  },
  [TaskType.SendWelcomeEmails]: {
    icon: faEnvelope,
    title: 'Send Welcome Emails',
    description: 'Introduce new members to your campaign with a welcoming message.',
  },
  [TaskType.SendProductCatalog]: {
    icon: faGift,
    title: 'Send Product Catalog',
    description: 'Enable members to browse and request product as part of this collaboration.',
  },
  [TaskType.SendContracts]: {
    icon: faFilePen,
    title: 'Send Contracts',
    description: 'Distribute legal agreements to your members for this campaign.',
  },
  [TaskType.SendPromoCodes]: {
    icon: faTags,
    title: 'Send Promo Codes',
    description: 'Share codes to track attribution and drive measurable sales from their audience.',
  },
  [TaskType.SendSalesLinks]: {
    icon: faTags,
    title: 'Send Sales Links',
    description: 'Provide trackable links for performance monitoring and commission attribution.',
  },
  [TaskType.CollaborateCreators]: {
    icon: faUserPlus,
    title: 'Find Creators',
    description: 'Reach out to creators who\'d be a great fit for this campaign.',
  },
  [TaskType.ReviewApplicants]: {
    icon: faUsers,
    title: 'Review Applicants',
    description: 'Go through creator applications and find the perfect matches.',
  },
  [TaskType.ConnectShopify]: {
    icon: faStore,
    title: 'Connect Shopify',
    description: 'Connect your Shopify account to enable members to request product.',
  },
  [TaskType.ConnectInstagram]: {
    icon: faCamera,
    title: 'Connect Instagram',
    description: 'Connect your Instagram account to enable Instagram-related capabilities.',
  },
  [TaskType.ConnectTikTok]: {
    icon: faVideo,
    title: 'Connect TikTok',
    description: 'Connect your TikTok account to enable Listening and Spark Ads.',
  },
  [TaskType.CreateCampaignWorkflow]: {
    icon: faListCheck,
    title: 'Create Workflow',
    description: 'Create a campaign workflow to follow each member’s journey and progress.',
  },
  [TaskType.DesignApplicationPage]: {
    icon: faPaintBrush,
    title: 'Design Application Page',
    description: 'Design your application to start generating interest.',
  },
  [TaskType.ConfigureBriefTemplate]: {
    icon: faFile,
    title: 'Configure Brief Template',
    description: 'Configure your brief template to quickly send briefs to members.',
  },
  [TaskType.SetupProductCatalog]: {
    icon: faGift,
    title: 'Setup Product Catalog',
    description: 'Set up your product catalog to enable creators to request products.',
  },
  [TaskType.DefineOffers]: {
    icon: faTags,
    title: 'Define Offers',
    description: 'Track sales by sharing out sales links and promo codes.',
  },
  [TaskType.ReviewAutomations]: {
    icon: faBolt,
    title: 'Review Automations',
    description: 'Speed up and scale your workflow by configuring automations.',
  },
  [TaskType.ReviewBudget]: {
    icon: faDollarSign,
    title: 'Review Budget',
    description: 'Finish setting up and allocating budget to track spend against revenue.',
  },
};
